import { render, staticRenderFns } from "./TextValue.vue?vue&type=template&id=3a8e91dd&scoped=true"
import script from "./TextValue.vue?vue&type=script&lang=js"
export * from "./TextValue.vue?vue&type=script&lang=js"
import style0 from "./TextValue.vue?vue&type=style&index=0&id=3a8e91dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e91dd",
  null
  
)

export default component.exports